import { useMemo } from "react"

export function useQueryParams<T>(): T {
  return useMemo<T>(() => {
    if (!window.location.search) {
      return {} as T;
    }

    const urlSearchParams = new URLSearchParams(window.location.search);
    return Object.fromEntries(Array.from(urlSearchParams.entries())) as T
  }, [])
}